import { createFileRoute, Link } from '@tanstack/react-router'
import { z } from 'zod'
import { LoginForm } from '@/components/auth/login-form'
import MkdnLogo from '@/components/ui/mkdn-logo'
import { requireGuest } from '@/lib/route-guards'

const search = z.object({
  documentId: z.string().optional(),
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: search,
  beforeLoad: requireGuest,
  component: LoginPage,
  head: () => ({ meta: [{ title: 'Login — mkdn.app' }] }),
})

function LoginPage() {
  const { documentId, redirect } = Route.useSearch()
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center gap-2 self-center font-medium">
          <MkdnLogo size="lg" />
        </Link>
        <LoginForm documentId={documentId} redirect={redirect} />
      </div>
    </div>
  )
}
